import { render, staticRenderFns } from "./MainEditorComponent.vue?vue&type=template&id=5b05db6b&scoped=true&"
import script from "./MainEditorComponent.vue?vue&type=script&lang=js&"
export * from "./MainEditorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05db6b",
  null
  
)

export default component.exports